import { render } from "./WpeInfo.vue?vue&type=template&id=39003ede"
import script from "./WpeInfo.vue?vue&type=script&lang=js"
export * from "./WpeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39003ede"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39003ede', __exports__)) {
    api.reload('39003ede', __exports__)
  }
  
  module.hot.accept("./WpeInfo.vue?vue&type=template&id=39003ede", () => {
    api.rerender('39003ede', render)
  })

}


export default __exports__